import AuthActionTypes from "./auth.types";

// Set the reducers initial state.
const INITIAL_STATE = {
    loading: false,
    signinSuccess: null,
    errorMessage: null,

    isCodeValid: false,
    appId: null,
    code: null,

    subscriptions: null,
    subscription: null,
    vertical: null,
    employee: null,
};

// Define scenarios for reducers.
const authReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AuthActionTypes.VALIDATE_CODE:
            return {
                ...state,
                isCodeValid: action.payload.isCodeValid,
                appId: action.payload.appId,
                code: action.payload.code,
            };
        case AuthActionTypes.SIGNIN_SUCCESS:
            return {
                ...state,
                signinSuccess: action.payload.signinSuccess,
                loading: action.payload.loading,
                employee: action.payload.employee,
                subscriptions: action.payload.subscriptions,
                subscription: action.payload.subscriptions !== null ? action.payload.subscriptions[0] : null,
            };
        case AuthActionTypes.SIGNIN_FAILURE:
            return {
                ...state,
                signinSuccess: action.payload.signinSuccess,
                loading: action.payload.loading,
                errorMessage: action.payload.err,
            };
        case AuthActionTypes.SIGN_OUT:
            return {
                ...state,
                subscriptions: null,
                subscription: null,
                vertical: null,
                employee: null,
                loading: false,
                signinSuccess: null,
                errorMessage: null,
            };
        case AuthActionTypes.UPDATE_SUBSCRIPTION:
            return {
                ...state,
                subscription: action.payload.subscription,
                vertical: null,
                employee: null,
            };
        case AuthActionTypes.UPDATE_EMPLOYEE:
            return {
                ...state,
                employee: action.payload.employee,
            };
        case AuthActionTypes.UPDATE_EMPLOYEE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default authReducer;
